import React, { useState } from "react";

import { Textarea, Typography, Button } from "clearsense-ui/components";
import { Edit } from "clearsense-ui/icons";
import ContentBox from "components/Common/ContentBox";

const InterfaceDefinitions = () => {
  const [isInboundInterfaceEditable, setIsInboundInterfaceEditable] =
    useState(false);
  const [isOutboundInterfaceEditable, setIsOutboundInterfaceEditable] =
    useState(false);
  return (
    <div className="flex gap-6 m-6">
      <ContentBox className="w-1/2 space-y-4">
        <div className="flex items-center justify-between">
          <Typography
            style="h4"
            type="semibold"
            className="mb-4 text-black dark:text-gray-400"
          >
            Inbound Interface
          </Typography>
          {!isInboundInterfaceEditable && (
            <Button
              style="text"
              icon={() => <Edit size={25} />}
              size="large"
              onClick={() => setIsInboundInterfaceEditable(true)}
            />
          )}
        </div>
        <Textarea
          label="Interfaced in from"
          placeholder="No data here"
          disabled={!isInboundInterfaceEditable}
        />
        <Textarea
          label="Interface Via"
          placeholder="No data here"
          disabled={!isInboundInterfaceEditable}
        />
        <Textarea
          label="Interface Schedule"
          placeholder="No data here"
          disabled={!isInboundInterfaceEditable}
        />
        <Textarea
          label="Interface Transformations"
          placeholder="No data here"
          disabled={!isInboundInterfaceEditable}
        />
        {isInboundInterfaceEditable && (
          <div className="flex items-center gap-2">
            <Button
              label="Save and Close"
              onClick={() => setIsInboundInterfaceEditable(false)}
            />
            <Button
              style="secondary"
              label="Discard"
              onClick={() => setIsInboundInterfaceEditable(false)}
            />
          </div>
        )}
      </ContentBox>
      <ContentBox className="w-1/2 space-y-4">
        <div className="flex items-center justify-between">
          <Typography
            style="h4"
            type="semibold"
            className="mb-4 text-black dark:text-gray-400"
          >
            Outbound Interface
          </Typography>
          {!isOutboundInterfaceEditable && (
            <Button
              style="text"
              icon={() => (
                <Edit
                  size={25}
                  onClick={() => setIsOutboundInterfaceEditable(true)}
                />
              )}
              size="large"
            />
          )}
        </div>
        <Textarea
          label="Interfaced out to"
          placeholder="No data here"
          disabled={!isOutboundInterfaceEditable}
        />
        <Textarea
          label="Interface Via"
          placeholder="No data here"
          disabled={!isOutboundInterfaceEditable}
        />
        <Textarea
          label="Interface Schedule"
          placeholder="No data here"
          disabled={!isOutboundInterfaceEditable}
        />
        <Textarea
          label="Interface Transformations"
          placeholder="No data here"
          disabled={!isOutboundInterfaceEditable}
        />
        {isOutboundInterfaceEditable && (
          <div className="flex items-center gap-2">
            <Button
              label="Save and Close"
              onClick={() => setIsOutboundInterfaceEditable(false)}
            />
            <Button
              style="secondary"
              label="Discard"
              onClick={() => setIsOutboundInterfaceEditable(false)}
            />
          </div>
        )}
      </ContentBox>
    </div>
  );
};

export default InterfaceDefinitions;
